import { CheckedAddress } from '@sparkdotfi/common-universal'
import { ScanEyeIcon } from 'lucide-react'

import { WalletMode } from '../TopbarWalletDropdown'
import { Address } from '@/ui/atoms/address/Address'
import { CopyButton } from '@/ui/molecules/copy-button/CopyButton'

interface TopbarWalletAddressDisplayProps {
  walletIcon: string
  address: CheckedAddress
  mode: WalletMode
}

function WalletIconDisplay({ walletIcon, mode }: { walletIcon: string; mode: WalletMode }) {
  return mode === 'watch-wallet' ? (
    <div className="flex aspect-square h-12 items-center justify-center md:h-6">
      <ScanEyeIcon className="icon-size-md md:icon-size-sm text-secondary" />
    </div>
  ) : (
    <img src={walletIcon} alt="Wallet icon" className="aspect-square h-12 md:h-6" />
  )
}

export function TopbarWalletAddressDisplay({ walletIcon, address, mode }: TopbarWalletAddressDisplayProps) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-sm bg-secondary p-10 md:p-6">
      <div className="rounded-full bg-primary p-1">
        <WalletIconDisplay walletIcon={walletIcon} mode={mode} />
      </div>

      <div className="typography-label-2 overflow-hidden text-primary">
        <div className="flex items-center gap-1">
          <Address compact address={address} />
          <CopyButton text={address} />
        </div>
      </div>
    </div>
  )
}
